module.exports = __webpack_public_path__ + "img/insurita-hero-image.6530ef72.png";